export const SCRAP_DISPLAY = {
  image: { x: -10, y: 2, width: 225, height: 82 },
  text: { x: 40, y: 50, font: 16 },
} as const;

export const BASE_HEALTH = {
  origin: { xFromCentre: -312, y: 0, width: 600, height: 40 },
  fillFraction: 0.83,
  barOffsetY: 6,
  barExtraHeight: 4,
  imageOffset: { x: -4, y: -10 },
  text: { font: 14, offsetY: 25, gap: 4, offsetYOver: 24, gapOver: 6 },
  colors: ['#465E84', '#A44E36'] as const,
} as const;

export const MINIMAP = {
  position: { x: 10, yFromBottom: -130, width: 120, height: 120 },
  frameInset: { x: -14, y: -22, width: 47, height: 43 },
  baseIconDivisor: 5,
  soccerBallDivisor: 6,
  controlPointDotDivisor: 12,
  controlPointIconDivisor: 4,
  ffaTargetDivisor: 4,
  crosshairColor: '#666',
  selfColor: '#FF1111',
  teamMarker: {
    size: 8,
    colors: ['#7A9BFF', '#FF7263'] as const,
    outline: '#0B0F1A',
    outlineWidth: 0.6,
  },
} as const;

export const LEADERBOARD = {
  position: { xFromRight: -210, y: 0, width: 230, height: 240 },
  imageOffsetX: -20,
  firstRowY: 46,
  rowHeight: 17,
  nameClip: { x: 10, widthFraction: 0.58, widthInset: -13 },
  nameX: 26,
  nameFont: 12,
  scoreXFraction: 0.6,
  scoreFont: 14,
  teamColors: ['#33D', '#C33'] as const,
  unnamed: '[Unnamed]',
  rank: { xFromRight: -105, y: 240, font: 16, color: '#77EEFF' },
} as const;

export const UPGRADE_DOCK = {
  buttonCount: 4,
  button: { width: 80, height: 100, spacing: 80 },
  originXFromCentre: -160,
  originYFromBottom: -40,
  liftedYOffset: -67,
  restingYOffset: -11,
  images: ['UpgradeQ', 'UpgradeW', 'UpgradeE', 'UpgradeR'] as const,
  dock: { image: 'UpgradeDock', xFromCentre: -224, yFromBottom: -40, width: 442, height: 40 },
  label: { offsetX: 7, offsetY: 18, font: 9 },
  level: { offsetX: 61, offsetY: 20, font: 13 },
  cost: { offsetX: 40, offsetY: 35, font: 12 },
  tooltip: { yFromBottom: -165, height: 40, textOffsetY: 28, font: 20, padding: 15 },
  textColor: '#111111',
  unaffordableColor: '#CC4444',
  maxLabel: 'Max',

  /** The clickable strip is narrower than the drawn button; a click on the outer 44px of a button fires the weapon instead of buying — kept as shipped, matching eleven years of muscle memory. */
  hit: { insetX: 22, width: 36, bandHeight: 80 },
} as const;

export const ABILITY_PANEL = {
  bar: { image: 'CooldownBar', xFromCentre: 235, yFromBottom: -55, width: 275, height: 55 },
  progress: { xFromCentre: 270, yFromBottom: -16, width: 105, height: 6 },
  timer: { xFromCentre: 384, yFromBottom: -10, font: 12 },
  name: { xFromCentre: 260, yFromBottom: -25, font: 12, color: '#eeeeee' },
  cost: { xFromCentre: 257, yFromBottom: -47, font: 10 },
  drones: { xFromCentre: 257, yFromBottom: -59, font: 10 },
  color: '#77EEFF',
  overColor: '#EE1111',
  readyLabel: 'Ready!',
} as const;

export const EVOLVE_SCREEN = {
  inset: 50,
  panel: { maxWidth: 1000, maxHeight: 700 },
  columnCentreFloor: 300,
  dim: { color: '#000', alpha: 0.55 },
  heading: { text: 'Upgrades', font: 30, baselineFromTop: 62, color: '#222' },
  portrait: { size: 200, topFromCentre: -150 },
  shipName: { font: 26, baselineFromCentre: -200, color: '#222' },
  ability: { font: 22, firstBaselineFromCentre: 110, lineHeight: 24, color: '#9bf04f' },
  choose: { label: 'Upgrade', topFromCentre: 196, width: 240, height: 62, font: 19 },
  key: { baselineFromCentre: 186, font: 16, color: '#333' },
  close: { label: 'close', widthFraction: 0.15, height: 48, centreYFromBottom: -33, font: 19 },
} as const;

export const LOADOUT_SCREEN = {
  inset: 50,
  panel: { maxWidth: 900, maxHeight: 780 },
  dim: { color: '#000', alpha: 0.55 },
  close: { label: 'Back', widthFraction: 0.16, height: 48, centreYFromBottom: -33, font: 19 },
  heading: { top: 30, font: 26, color: '#222' },
  credits: { top: 28, right: 160, font: 19, labelFont: 12 },
  portrait: { top: 90, left: 40, size: 140 },
  shipSelect: { top: 24, left: 24, width: 200, font: 13 },
  stats: { top: 90, left: 200, width: 660 },
  row: { height: 40, marginBottom: 8 },
  label: { width: 100, font: 14 },
  pill: { width: 11, height: 10, borderRadius: 3, gap: 5, groupGap: 2 },
  readout: { width: 62, marginLeft: 8, font: 13 },
  stepper: { width: 30, height: 30, marginLeft: 4, font: 16 },
  slots: { top: 386, left: 40, width: 820, height: 170, gap: 20, slotWidth: 260, slotHeight: 150 },
  slotLabel: { font: 12 },
  ability: { font: 20, color: '#9bf04f' },
  locked: { font: 11, color: '#666' },
  footer: { bottom: 44 },
  remaining: { font: 16 },
  confirm: { font: 15, paddingV: 25, paddingH: 45 },
  picker: {
    panel: { maxWidth: 540, maxHeight: 620 },
    heading: { top: 28, font: 20, color: '#222' },
    list: { top: 72, side: 34, bottom: 92 },
    row: { height: 36, font: 15, gap: 12, abbrWidth: 54, abbrFont: 12 },
    cancel: { bottom: 30, font: 12 },
  },
} as const;

export const DEATH_SCREEN = {
  heading: { y: 120, font: 30, color: '#FFF' },
  hint: { y: 142, font: 14 },
  tip: { yFromBottom: -160, font: 16 },
} as const;

export const PROGRESS_BAR = {
  troughColor: '#111111',
  troughAlpha: 0.3,
  defaultColor: '#465E84',
} as const;

/** Not a nine-slice — docs/ui-panel-frame.md. `fill` is where the tiled centre stops (not `border`, or a gap shows); `edge` is transparent margin the border must stay inside (or it pokes past a corner). */
export const FRAME_SLICE = {
  border: { left: 22, right: 22, top: 20, bottom: 24 },
  fill: { left: 16, right: 17, top: 14, bottom: 18 },
  edge: { left: 8, right: 9, top: 4, bottom: 0 },
  ornament: { topWidth: 182, topHeight: 52, bottomWidth: 98, bottomHeight: 64 },
  minimumWidth: 380,
  minimumHeight: 120,
} as const;

export const EMOJI = { size: 45, offsetY: 55, lifetimeMs: 3000 } as const;

export const NOTIFICATION = {
  y: 75,
  font: 20,
  color: '#EE1111',
  lifetimeMs: 15_000,
} as const;

export const CHAT = {
  maxLines: 5,
  maxLength: 120,
  placeholder: 'Say something…',
  startXFraction: 0.01,
  startYFractionFromBottom: 0.25,
  font: 20,
  widthHeightFraction: 0.5,
  maxHeightFraction: 0.35,
  teamColors: ['#FF1111', '#1111FF', '#C9CFDB'] as const,
} as const;

export const EVENT_WINDOW = {
  pendingLabel: 'Special mode in:',
  runningLabel: 'Game mode ends in:',
  announceHorizonMs: 5 * 60 * 60 * 1000,
  rightMargin: 10,
  labelY: 280,
  countdownY: 294,
  font: 14,
  color: '#EE1111',
} as const;

export const END_GAME = {
  lifetimeMs: 9500,
  panel: { width: 720, height: 520 },
  dim: { color: '#444', alpha: 0.85 },
  heading: { font: 32, baselineFromTop: 80 },
  rankLine: { font: 24, baselineFromTop: 114 },
  rows: {
    font: 23,
    firstBaselineFromTop: 160,
    lineHeight: 29,
    labelGap: 5,
    valueGap: 15,
    hingeFromCentre: 62,
  },
  total: { font: 34, scoreGap: 48, creditsGap: 92, creditsFont: 29 },
  teamLabels: ['Blue', 'Red'] as const,
  teamColors: ['#8098ff', '#ff7263'] as const,
  teamShadows: ['#000a4d', '#3d0000'] as const,
  ink: '#111111',
  good: '#43d155',
  bad: '#ff7263',
  middling: '#ffbb42',
  minimumRankedField: 3,
  notLoggedIn: 'Not logged In',
} as const;
